export interface ActionsBarProps {
  onDiscard: () => void;
  onLike: () => void;
  onFavorite: () => void;
}

// Button size constants
export const BUTTON_SIZE_SMALL = 80;
export const BUTTON_SIZE_LARGE = 100;
export const ICON_SIZE_SMALL = 36;
export const ICON_SIZE_LARGE = 42;

// For web
export const BUTTON_SIZE_SMALL_WEB = 70;
export const BUTTON_SIZE_LARGE_WEB = 90;
export const ICON_SIZE_SMALL_WEB = 32;
export const ICON_SIZE_LARGE_WEB = 38;
